import { atom, selector } from 'recoil';
import {
  GetDashboardFacilityDtoRx,
  GetDashboardRegionDtoRx,
} from '@/sdk/data-contracts';

export const dashboardFacilityRecoil = atom<GetDashboardFacilityDtoRx | null>({
  key: 'dashboardFacilityRecoil',
  default: null,
});

export const dashboardRegionRecoil = atom<GetDashboardRegionDtoRx | null>({
  key: 'dashboardRegionRecoil',
  default: null,
});
